import type { Catalog } from "../../en";
import { actions } from "./actions";
import { agentKnowledge } from "./agent-knowledge";
import { agentSettings } from "./agent-settings";
import { agents } from "./agents";
import { evaluations } from "./evaluations";
import { playground } from "./playground";

/** Filipino: build console screens (mirrors en/build). */
export const build: Catalog["build"] = {
  planGate: {
    title: "Kailangan ng mas mataas na plano para sa {{feature}}",
    badge: "Feature ng plano",
    body: "Hindi kasama ito sa kasalukuyan mong plano. Mag-upgrade para magamit ito — nananatili ang iyong settings.",
    upgrade: "Ikumpara ang mga plano",
  },
  status: { live: "Live", paused: "Naka-pause", draft: "Draft" },
  time: {
    now: "ngayon lang",
    minutes_one: "{{count}} minuto ang nakalipas",
    minutes_other: "{{count}} minuto ang nakalipas",
    hours_one: "{{count}} oras ang nakalipas",
    hours_other: "{{count}} oras ang nakalipas",
    yesterday: "Kahapon",
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
    slack: "Slack",
    teams: "Teams",
  },
  loadError: "Hindi ma-load ang page na ito.",
  loadErrorBody: "Tingnan ang iyong koneksyon at subukan muli. Walang nawala.",
  noPermission: "Wala kang pahintulot na baguhin ito",
  readOnly: "Read-only habang may support session",
  noAgent: "Pumili muna ng agent",
  noAgentBody: "Para sa isang agent ang page na ito. Pumili mula sa listahan ng mga agent.",
  goToAgents: "Pumunta sa mga agent",
  agents,
  agentKnowledge,
  agentSettings,
  playground,
  actions,
  evaluations,
};
